import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles.css";
import { aplicarAlArrancar } from "./tamano-de-letra";

/*
 * El tamaño de letra guardado se pone ANTES de pintar.
 *
 * Dentro de un componente, la primera pantalla saldría con el tamaño de
 * siempre y daría un salto al montarse. Cien veces al día, ese salto se nota
 * más que el propio tamaño.
 */
aplicarAlArrancar();

const root = document.getElementById("root");
if (!root) throw new Error("Falta #root en index.html");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
